export const TopupFormStatuses = {
  FAIL: 'fail',
  SUCCESS: 'success'
};

type TopupFormStatusesKeys = keyof typeof TopupFormStatuses;

export type TopupFormStatusesType =
  (typeof TopupFormStatuses)[TopupFormStatusesKeys];
